import React from 'react';
import styles from '../../styles/WhatIsRigging.module.css';

function WhatIsRigging() {
    return (
        <section className={styles.container}>
            <div className={styles.content}>
                <h2 className={styles.title}>What is Rigging?</h2>
                <p className={styles.description}>
                    "Rigging" refers to the process of creating mechanisms that allow CG models to move. 
                    This involves adding bones to polygons, setting their influence, and creating controllers. 
                    The quality of rigging is directly linked to the quality of CG expression.
                </p>
            </div>
        </section>
    );
}

export default WhatIsRigging;
